import { FieldValues, UseFormGetValues, UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { IAnswer, IEmpManyOfMany } from '@/models'
import { Text } from '@/components/ui'
import { SelectAnswer } from '../ui'

interface IEmpManyOfManyQuestionProps {
  question: IEmpManyOfMany
  register: UseFormRegister<FieldValues>
  setValue: UseFormSetValue<FieldValues>
  getValues: UseFormGetValues<FieldValues>
}

const EmpManyOfManyQuestion = ({ question, register, setValue, getValues }: IEmpManyOfManyQuestionProps) => {
  const usersLength: number = question?.users?.length

  if (!usersLength) {
    return (
      <Text as='p' size='md'>
        Нет сотрудников для оценки. Можете продолжить опрос
      </Text>
    )
  }

  return (
    <>
      {question.users.map((user: IAnswer, i: number) => (
        <SelectAnswer
          key={user.uuid}
          name={`${question.id}.${i}`}
          register={register}
          value={user.uuid}
          onChange={(e) => {
            e.preventDefault()
            const key = `${question.id}.${i}`
            setValue(key, getValues(key) === false ? user.uuid : false)
          }}
        >
          <Text>{user?.title}</Text>
        </SelectAnswer>
      ))}
    </>
  )
}

export default EmpManyOfManyQuestion
